<template>
  <div class="view-account container py-4 mb-5">
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7 py-5">
        <change-password @back="$router.push({ name: 'account' })" />
      </div>
    </div>
  </div>
</template>

<script>
import ChangePassword from "@/components/account/ChangePassword";

export default {
  components: { ChangePassword }
};
</script>
